// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"e7f6c95c","337":"a19c97e5","472":"a19c97e5","522":"e7f6c95c"}[chunkId] + ".chunk.css";
};